import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=36248585&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
import style0 from "./Register.vue?vue&type=style&index=0&id=36248585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36248585",
  null
  
)

export default component.exports